export default "__VITE_ASSET__4703e012__"